import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  Jaarrapportage,
  ClientEntity, LegalSizeCriteria,
} from '@snelstart-ventures/fiscaal/domain-logic';
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SelectFormControlItem, SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {filter, Subscription} from "rxjs";
import {Event, NavigationEnd, Router} from "@angular/router";
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {CommonModule} from '@angular/common';
import {SharedUiTooltipTriggerModule} from "@snelstart/ui-tooltip-trigger";
import {SharedUiButtonModule} from "@snelstart/ui-button";
import {SharedUiDialogModule} from "@snelstart/ui-dialog";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-info-onderneming',
  templateUrl: './info-onderneming.component.html',
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule,
    SharedUiTooltipTriggerModule,
    SharedUiButtonModule,
    SharedUiDialogModule
  ],
  styleUrls: ['./info-onderneming.component.scss']
})
export class InfoOndernemingComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private routerSubscription: Subscription | undefined;
  private entitySubscription: Subscription | undefined;
  private clientSubscription: Subscription | undefined;
  private isSaving = false;
  public jrEntity = {} as JaarrapportageEntity;
  public clientEntity = {} as ClientEntity;
  public informatieEntiteitFg = {} as FormGroup;
  public isRechtspersoon = false;
  public heeftAandelen = false;
  public changeLegalSizeDialogVisible = false;
  pendingValueLegalSize: any;
  lastValueLegalSize: any;

  public optionsLegalFormLegalEntity: SelectFormControlItem<string>[] = [
    {value: "BV", label: "Besloten vennootschap met beperkte aansprakelijkheid"},
    {value: "NV", label: "Naamloze vennootschap"},
    {value: "COOPERATIE", label: "Coöperatie"},
    {value: "STICHTING", label: "Stichting", disabled: true},
    {value: "VERENIGING", label: "Vereniging", disabled: true},
  ];

  public optionsLegalFormNaturalPersons: SelectFormControlItem<string>[] = [
    {value: "EENMANSZAAK", label: "Eenmanszaak"},
    {value: "VOF", label: "Vennootschap onder firma"},
    {value: "MAATSCHAP", label: "Maatschap"},
    {value: "CV", label: "Commanditaire vennootschap"},
  ];

  public optionsLegalSize: SelectFormControlItem<string>[] = [
    {value: "MICRO", label: "Micro"},
    {value: "KLEIN", label: "Klein"},
    // {value: "MIDDELGROOT", label: "Middelgroot", disabled: true},
    // {value: "GROOT", label: "Groot", disabled: true},
  ];

  onLegalSizeValueChange() {
    this.pendingValueLegalSize=this.informatieEntiteitFg.getRawValue().legalSizeCriteriaClassification?.value;
    this.changeLegalSizeDialogVisible = true;
  }

  cancelChange() {
    this.informatieEntiteitFg.patchValue({
      legalSizeCriteriaClassification: {
        value: this.lastValueLegalSize,
      }
    },{emitEvent: false});
    this.changeLegalSizeDialogVisible = false;
    setTimeout(()=>{
      this.pendingValueLegalSize = null;
    },250)  }

  confirmChange() {
    this.lastValueLegalSize = this.pendingValueLegalSize;
    this.saveForm();
    this.changeLegalSizeDialogVisible = false;
    setTimeout(()=>{
      this.pendingValueLegalSize = null;
    },250)
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService,
    private router: Router,
    private fb: FormBuilder) {
    this.algDataService.client.subscribe((value) => {
      this.clientEntity = value;
      if (value) {
        this.informatieEntiteitFg = this.fb.group({
          legalEntityName: this.fb.group({
            value: this.clientEntity.name
          }),
          legalEntityLegalForm: this.fb.group({
            value: this.clientEntity.rechtsvorm === 'BV' ? 'BV'
              : this.clientEntity.rechtsvorm === 'EENMANSZAAK' ? 'EENMANSZAAK'
                : undefined
          }),
          legalEntityLegalFormNPOtherDescription: this.fb.group({
            value: null as unknown as string,
          }),
          legalEntityRegisteredOffice: this.fb.group({
            value: this.clientEntity.place
          }),
          chamberOfCommerceRegistrationNumber: this.fb.group({
            value: null as unknown as string
          }),
          businessNames: this.fb.group({
            value: this.clientEntity.name
          }),
          legalSizeCriteriaClassification: this.fb.group({
            value: null as unknown as LegalSizeCriteria
          }),
          sbiBusinessCode: this.fb.group({
            value: null as unknown as string
          }),
          dateEstablishmentLegalEntity: this.fb.group({
            value: null as unknown as Date,
          }),
          dateChangeRegulationsLegalEntity: this.fb.group({
            value: null as unknown as Date,
          }),
          numberOfBusinessPartnersInFTEsDecimals: this.fb.group({
            value: null as unknown as number,
          }),
          adres: this.fb.group({
            streetNameNL: this.fb.group({
              value: this.clientEntity.street
            }),
            houseNumberNL: this.fb.group({
              value: this.clientEntity.houseNumber
            }),
            houseNumberAddition: this.fb.group({
              value: this.clientEntity.numberAddition
            }),
            poBoxNumber: this.fb.group({
              value: null as unknown as string
            }),
            postalCodeNL: this.fb.group({
              value: this.clientEntity.postalCode
            }),
            placeOfResidenceNL: this.fb.group({
              value: this.clientEntity.place
            }),
            descriptionLocationAbroad: this.fb.group({
              value: null as unknown as string
            }),
            streetNameAbroad: this.fb.group({
              value: null as unknown as string
            }),
            houseNumberAbroad: this.fb.group({
              value: null as unknown as string
            }),
            postalCodeAbroad: this.fb.group({
              value: null as unknown as string
            }),
            placeOfResidenceAbroad: this.fb.group({
              value: null as unknown as string
            }),
            nameRegion: this.fb.group({
              value: null as unknown as string
            }),
            countryName: this.fb.group({
              value: null as unknown as string
            }),
            descriptionLocationNL: this.fb.group({
              value: null as unknown as string
            }),
          })
        })
      }
    });
  }

  ngOnInit(): void {
    this.entitySubscription = this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.jrEntity = value;
      const item = value.rapportage?.informatieEntiteit;
      if (item) {
        this.informatieEntiteitFg.patchValue(item, {emitEvent: false})
        this.lastValueLegalSize = item.legalSizeCriteriaClassification?.value
      }
    })
    this.clientSubscription = this.algDataService.client.subscribe((value) => {
      this.clientEntity = value;
    })
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
    this.jrDataService.heeftAandelen.subscribe((value) => {
      this.heeftAandelen = value;
    })
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleUrlChange(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.entitySubscription) {
      this.entitySubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.clientSubscription) {
      this.clientSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
  }

  saveForm(): void {
    this.informatieEntiteitFg.updateValueAndValidity();
    setTimeout(() => {
      this.jrEntity = {
        ...this.jrEntity,
        rapportage: {
          ...this.jrEntity.rapportage,
          informatieEntiteit: {
            ...this.jrEntity.rapportage?.informatieEntiteit,
            legalEntityName: this.informatieEntiteitFg.getRawValue().legalEntityName,
            legalEntityLegalForm: this.informatieEntiteitFg.value.legalEntityLegalForm,
            legalEntityLegalFormNPOtherDescription: this.informatieEntiteitFg.value.legalEntityLegalFormNPOtherDescription,
            legalEntityRegisteredOffice: this.informatieEntiteitFg.value.legalEntityRegisteredOffice,
            chamberOfCommerceRegistrationNumber: this.informatieEntiteitFg.value.chamberOfCommerceRegistrationNumber,
            businessNames: this.informatieEntiteitFg.value.businessNames,
            legalSizeCriteriaClassification: this.informatieEntiteitFg.getRawValue().legalSizeCriteriaClassification,
            sbiBusinessCode: this.informatieEntiteitFg.value.sbiBusinessCode,
            dateEstablishmentLegalEntity: this.informatieEntiteitFg.value.dateEstablishmentLegalEntity,
            dateChangeRegulationsLegalEntity: this.informatieEntiteitFg.value.dateChangeRegulationsLegalEntity,
            numberOfBusinessPartnersInFTEsDecimals: this.informatieEntiteitFg.value.numberOfBusinessPartnersInFTEsDecimals,
            adres: this.informatieEntiteitFg.value.adres
          }
        }
      } as Jaarrapportage
      this.jrDataService.updateEntity(this.jrEntity);
    }, 0)
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.jrDataService.updateEntity(this.jrEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.informatieEntiteitFg.dirty;
  }
}
